export default __webpack_public_path__ + "static/proxima-nova-300-i-fbe0691c4b8a4854e551b2f859231f32.woff";